<template>
	<div id="MAM_terminalList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">

				<el-form-item>
					<el-input size clearable v-model="formInline.terminal_sn" placeholder="请输入SN"></el-input>
				</el-form-item>


				<el-form-item>
					<el-input size clearable v-model="formInline.phone" placeholder="请输入直属代理商账号"></el-input>
				</el-form-item>

				<el-form-item>
					<el-input size clearable v-model="formInline.agent_no" placeholder="请输入直属代理商编号"></el-input>
				</el-form-item>
                <el-form-item v-if="level < 2">
                	<el-input size clearable v-model="formInline.p2_phone" placeholder="请输入所属代理商账号"></el-input>
                </el-form-item>
                
                <el-form-item v-if="level < 2">
                	<el-input size clearable v-model="formInline.p2_agent_no" placeholder="请输入所属代理商编号"></el-input>
                </el-form-item>

				<el-form-item>
					<el-select size="medium" v-model="formInline.brand_id" filterable clearable style="width:100%"
						placeholder="请选择政策">
						<el-option v-for="(item,index) in brandList" :key="index" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-select size="medium" v-model="formInline.terminal_type" filterable clearable style="width:100%"
						placeholder="请选择终端类型">
						<el-option label="银盛POS" value="1"></el-option>
						<el-option label="手机POS" value="2"></el-option>
						<el-option label="杉德POS" value="3"></el-option>
						<el-option label="联动POS" value="4"></el-option>
                        <el-option label="海科POS" value="5"></el-option>
                        <el-option label="银盛尊享POS" value="6"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-select size v-model="formInline.bd_status" clearable placeholder="请选择绑定状态">
						<el-option label="未绑定" value="2"></el-option>
						<el-option label="已绑定" value="1"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-select size v-model="formInline.jh_status" clearable placeholder="请选择激活状态">
						<el-option label="未激活" value="2"></el-option>
						<el-option label="已激活" value="1"></el-option>
					</el-select>
				</el-form-item>

				<!--  <el-form-item>
                    <el-input size clearable v-model="formInline.zc" placeholder="请输入政策"></el-input>
                </el-form-item>-->

				<el-form-item>
					<el-input size clearable v-model="formInline.merchant_number" placeholder="请输入商户编号"></el-input>
				</el-form-item>


				<!--<el-form-item>
                    <el-input size clearable v-model="formInline.num_start" placeholder="请输入起始号段"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input size clearable v-model="formInline.num_end" placeholder="请输入终止号段"></el-input>
                </el-form-item>-->

				<el-form-item>
					<el-date-picker v-model="rangeDate" type="daterange" range-separator="至" start-placeholder="绑定开始日期"
						end-placeholder="绑定结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
						@change="pickerChange"></el-date-picker>
				</el-form-item>

				<el-form-item>
					<el-date-picker v-model="rangeDate2" type="daterange" range-separator="至" start-placeholder="激活开始日期"
						end-placeholder="激活结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions2"
						@change="pickerChange2"></el-date-picker>
				</el-form-item>

				<!-- <el-form-item>
				    <el-select size v-model="formInline.is_exchange" clearable placeholder="请选择兑换状态">
				        <el-option label="未兑换" value="0"></el-option>
				        <el-option label="已兑换" value="1"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item>
				    <el-date-picker
				            v-model="rangeDate3"
				            type="daterange"
				            range-separator="至"
				            start-placeholder="兑换开始日期"
				            end-placeholder="兑换结束日期"
				            value-format="yyyy-MM-dd"
				            @change="pickerChange3"
				    ></el-date-picker>
				</el-form-item> -->


				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(formInline)">查询</el-button>
					<el-button size="medium" type="primary" icon="el-icon-download" style="font-size: 12px;"
						@click="downLoad(formInline)">导出数据</el-button>
					<el-button @click="handleEdit()" type="primary" size="small">终端默认政策设置
					</el-button>
					<!--                   <el-button v-if="level>0"
                            @click="rateEdit()"
                            type="primary"
                            size="small"  
                    >终端默认费率设置
                    </el-button> -->
					<!-- <el-button v-if="level == 1" @click="terminalExtend()" type="primary" size="small">延长激活时间</el-button> -->
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom: 10px;">
				<div class="tableTitle">
					<span class="st-label">总设备数：</span>
					<span
						class="st-word-aux">{{tableTitle.total}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

					<span class="st-label">总绑定数：</span>
					<span
						class="st-word-aux">{{tableTitle.total_bind}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

					<span class="st-label">总激活数：</span>
					<span
						class="st-word-aux">{{tableTitle.total_active}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
				</div>
			</div>
			<el-table :data="transferList.list" size="mini" border style="width: 100%" v-loading="loading"
				v-model="checkbox" @selection-change="changeFun">

				<el-table-column header-align="center" align="center" fixed type="selection" label="ID" min-width="80">
				</el-table-column>
				<!-- SN号 -->
				<el-table-column header-align="center" align="center" prop="sn" label="SN号"
					min-width="200"></el-table-column>
					
				<el-table-column header-align="center" align="center" prop="terminal_channel" label="终端类型"
					min-width="100"></el-table-column>
					
				<el-table-column header-align="center" align="center" prop="agent_name" label="主机构" min-width="140"
					v-if="level == 0"></el-table-column>
				<!--                <el-table-column
                        header-align="center"
                        align="center"
                        prop="deal_time"
                        label="入库时间"
                        min-width="140"
                        v-if="level >= 1"
                ></el-table-column> -->
				<!-- 所属代理商 -->
				<el-table-column header-align="center" align="center" prop="nickname" label="终端直属代理昵称"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="phone" label="终端直属代理账号" min-width="120">
				</el-table-column>
				<!-- 所属代理商编号 -->
				<el-table-column header-align="center" align="center" prop="agent_no" label="终端直属代理编号" min-width="150">
				</el-table-column>
                
                <el-table-column v-if="level < 2" header-align="center" align="center" prop="p2_nickname" label="终端所属代理昵称"
                	min-width="120"></el-table-column>
                <el-table-column v-if="level < 2"  header-align="center" align="center" prop="p2_phone" label="终端所属代理账号" min-width="120">
                </el-table-column>
                <!-- 所属代理商编号 -->
                <el-table-column v-if="level < 2"  header-align="center" align="center" prop="p2_agent_no" label="终端所属代理编号" min-width="150">
                </el-table-column>
				<!-- 终端名称 -->
				<el-table-column header-align="center" align="center" prop="brand_name" label="终端名称"
					min-width="130"></el-table-column>
				<!-- 设备型号 -->
				<el-table-column header-align="center" align="center" prop="term_type" label="设备型号" min-width="80">
				</el-table-column>
				<!-- 政策 -->
				<el-table-column header-align="center" align="center" prop="zc" label="政策"
					min-width="160"></el-table-column>
				<!-- 商户编号 -->
				<el-table-column header-align="center" align="center" prop="merchant_number" label="商户编号"
					min-width="150">
				</el-table-column>
				<!--                <el-table-column
                        header-align="center"
                        align="center"
                        prop="endtime"
                        label="激活截止时间"
                        min-width="120"
                >
                </el-table-column> -->
				<!-- 绑定状态 -->
				<el-table-column header-align="center" align="center" prop="is_bind" label="绑定状态" min-width="80">
					<template slot-scope="scope">
						<p v-if="scope.row.is_bind=='已绑定'" style="color:green" v-html="scope.row.is_bind"></p>
						<p v-if="scope.row.is_bind=='未绑定'" style="color:red" v-html="scope.row.is_bind"></p>
					</template>
				</el-table-column>
				<!-- 激活状态 -->
				<!-- 商户编号 -->
				<el-table-column header-align="center" align="center" prop="bind_time" label="绑定时间" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="is_active" label="激活状态" min-width="80">
					<template slot-scope="scope">
						<p v-if="scope.row.is_active=='已激活'" style="color:green" v-html="scope.row.is_active"></p>
						<p v-if="scope.row.is_active=='未激活'" style="color:red" v-html="scope.row.is_active"></p>
					</template>
				</el-table-column>
				<!-- 商户编号 -->
				<el-table-column header-align="center" align="center" prop="active_time" label="激活时间" min-width="150">
				</el-table-column>


				<!-- <el-table-column
				    header-align="center"
				    align="center"
				    prop="is_exchange"
				    label="兑换状态"
				    min-width="80"
				>
					<template slot-scope="scope">
						<p  v-if="scope.row.is_exchange=='未兑换'" style="color:green" v-html="scope.row.is_exchange"></p>
						<p  v-if="scope.row.is_exchange=='已兑换'" style="color:red" v-html="scope.row.is_exchange"></p>
					</template>
				</el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="exchange_time"
				    label="兑换时间"
				    min-width="150"
				>
				</el-table-column> -->

				<el-table-column header-align="center" align="center" prop="create_time" label="入库时间" min-width="150">
				</el-table-column>
				<!-- <el-table-column
				    header-align="center"
				    align="center"
				    prop="jiezhi_time"
				    label="风控截止时间"
				    min-width="150"
				>
				</el-table-column> -->
				<!-- 操作 -->
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="170">
					<template slot-scope="scope">
						<div class="terminal_operate">
							<el-button @click="handleInfo(scope.row)" type="text" size="small">查看</el-button>
							<el-button @click='goTo(scope.row)' type="text" size="small">交易明细</el-button>
							<!-- <el-button v-if="isActivation(scope.row)" @click='delayActiv(scope.row)'  type="text" size="small">延迟激活</el-button> -->
						</div>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize" style="text-align: center"></paginations>
		</el-card>
		<!-- 查看 -->
		<terminal-detail v-if="infoIsShow" :infoIsShow="infoIsShow" :detail="detail" @infoClose="infoClose">

		</terminal-detail>
		<edit-info v-if="editShow" :infoIsShow="editShow" :detail="detail" :idsArray="ids" :brandidsArray="brandids"
			:isactiveArray="isactive" :isbindArray="isbind" :useridArray="userid" @infoClose="infoClose">
		</edit-info>
		<!-- 费率修改 -->
		<rate-info v-if="rateIsShow" :rateIsShow="rateIsShow" :idsArray="ids" :brandidsArray="brandids"
			:isactiveArray="isactive" :isbindArray="isbind" :useridArray="userid" :detail="detail"
			@infoClose="infoClose">
		</rate-info>
		<search-result v-if="statusIsShow" :statusIsShow="statusIsShow" :detail="detail"
			@infoClose="infoClose"></search-result>
		<!--延迟激活-->
		<activ-show v-if="delayActivShow" :array="delayActivInfo" @infoClose="infoClose"></activ-show>
		<div v-if="is_show_activation_box"
			style="position:fixed;top:0;left:0;display:flex;justify-content:center;align-items:center;height:100%;width:100%;background-color:rgba(0,0,0,0.5);z-index:999">
			<el-card class="box-card" style="width:30%;">

				<div slot="header" class="clearfix">
					<div style="display:flex;justify-content:flex-end"><i @click="terminalExtend()"
							class="el-icon-close"></i></div>
					<span>延迟激活</span>
				</div>
				<div>
					<el-form :inline="true" :model="formInline" class="demo-form-inline">
						<el-form-item>
							<el-input size clearable type="number" v-model="activation_day"
								placeholder="请输入延长天数"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div style="display:flex;justify-content:center;margin-top:20px;">
					<el-button @click="delayBtn()" type="primary" size="small">确认延迟</el-button>
				</div>

			</el-card>
		</div>
	</div>

</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	import terminalDetail from './MAM_terminalDetail';
	import searchResult from './MAM_searchResult';
	import editInfo from './MAM_editInfo';
	import rateInfo from './MAM_rateInfo';
	import activShow from './MAM_activShow';
	export default {
		name: "MAM_terminalList",
		data() {
			return {
				ids: [], //选中终端id
				brandids: [], //选中终端品牌
				sn: [], //终端sn
				isactive: [], //选中终端激活状态
				isbind: [], //选中终端绑定状态
				userid: [], //选中终端用户id
				tableTitle: {
					total: 0, //总设备数
					total_bind: 0, //总绑定数
					total_active: 0, //总激活数
				},
				level: sessionStorage.getItem('level'),
				admin_id: sessionStorage.getItem('admin_id'),
				pickerOptions: {}, //绑定日期
				pickerOptions2: {}, //激活日期
				infoIsShow: false, //查看弹窗
				statusIsShow: false,
				editShow: false, //修改奖励弹窗
				rateIsShow: false, //费率修改弹窗
				listId: null, //
				detail: {}, //当前行
				brandList: [],
				agentList: [],
				rangeDate: [], //绑定日期
				rangeDate2: [], //激活日期
				rangeDate3: [],
				formInline: {
					terminal_sn: '', //sn
					transfer_user_name: '', //代理商
					brand_id: '', //选择政策id
					bd_status: '', //绑定状态
					terminal_type:'',
					jh_status: '', //激活状态
					zc: '', //政策
					order_num: '', //商户编号
					num_start: '', //起始号段
					num_end: '', //终止号段
					bd_start: '', //绑定开始时间
					bd_end: '', //绑定结束时间
					jh_start: '', //激活开始时间
					jh_end: '', //激活结束时间
					phone: '', //代理商手机号
					agent_no: '', //代理商手机号
					is_exchange: '',
					exchange_time_start: '',
					exchange_time_end: '',
                    p2_phone:'',
                    p2_agent_no:''
				},

				transferList: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				loading: true,
				checkbox: '',
				delayActivShow: false, //显示当前选择延长弹框
				delayActivInfo: "", //当前延迟激活设备信息
				is_show_activation_box: false, //延迟弹框
				activation_day: 0, //延迟天数
			}
		},
		created() {
			this.pickerOptions.disabledDate = (time) => { //禁用日期
				if (this.currentDate !== '') {
					let tempTime = 3600 * 1000 * 24 * 30;
					let timer = new Date(this.currentDate).getTime();
					let minTime = timer - tempTime;
					let maxTime = timer + tempTime;
					return time.getTime() < minTime || time.getTime() > Date.now() || time.getTime() > maxTime;
				}
				return time.getTime() > Date.now();
			}
			this.pickerOptions.onPick = ({
				minDate,
				maxDate
			}) => { //当前选中的日期
				this.currentDate = minDate.getTime();
				if (maxDate) {
					this.currentDate = '';
				}
			}

			this.pickerOptions2.disabledDate = (time) => { //禁用日期
				if (this.currentDate !== '') {
					let tempTime = 3600 * 1000 * 24 * 30;
					let timer = new Date(this.currentDate).getTime();
					let minTime = timer - tempTime;
					let maxTime = timer + tempTime;
					return time.getTime() < minTime || time.getTime() > Date.now() || time.getTime() > maxTime;
				}
				return time.getTime() > Date.now();
			}
			this.pickerOptions2.onPick = ({
				minDate,
				maxDate
			}) => { //当前选中的日期
				this.currentDate = minDate.getTime();
				if (maxDate) {
					this.currentDate = '';
				}
			}
		},
		mounted() {
			this.getData({
				condition: JSON.stringify(this.formInline),
				page: this.page.currentPage,
				limit: this.page.pageSize,
			})
			this.$api.post('brand/brand_list', {}, res => { //获取选择政策
				if (res.code == 0) {
					this.brandList = res.data.list;
				} else {
					this.$$message.success(res.msg);
				}
			});
			// this.getData({
			//     page: 1,
			//     limit: 10
			// })
		},
		components: {
			paginations,
			terminalDetail,
			searchResult,
			editInfo, //修改政策
			rateInfo,
			activShow, //延迟激活弹框
		},
		methods: {
			changeFun(row) {
				this.ids = []; //选中终端id
				this.sn = []
				this.brandids = []; //选中终端品牌
				this.isactive = []; //选中终端激活状态
				this.isbind = []; //选中终端绑定状态
				this.userid = []; //选中终端用户id
				if (row.length != 0) {
					this._.forEach(row, item => {
						this.ids.push(item.id);
						this.sn.push(item.sn);
						this.brandids.push(item.brand_id);
						this.isactive.push(item.is_active);
						this.isbind.push(item.is_bind);
						this.userid.push(item.user_id);
					})
				}
			},
			onSearch() { //搜索
				this.page.currentPage = 1;
				// 表单提交
				this.getData({
					condition: JSON.stringify(this.formInline),
					page: 1,
					limit: this.page.pageSize,
				})
			},
			// downLoad() { //下载
			//     this.page.currentPage = 1;
			//     // 表单提交
			//     this.getData({
			//         condition: JSON.stringify(this.formInline),
			//         page: 1,
			//         limit: this.page.pageSize,
			//     })
			// },
			infoClose() {
				this.infoIsShow = false;
				this.statusIsShow = false;
				this.editShow = false;
				this.rateIsShow = false;
				this.delayActivShow = false; //关闭延迟激活弹框
				this.getData({
					condition: JSON.stringify(this.formInline),
					page: this.page.currentPage,
					limit: this.page.pageSize,
				})
			},
			handleInfo(row) { //查看
				this.infoIsShow = true;
				this.detail = row;
			},
			handleInfos(row) { //查看
				this.statusIsShow = true;
				this.detail = row;
			},
			handleEdit() { //编辑
				if (this.ids.length > 0) {
					this.$api.post("terminal/checkTerminalSearch", {
						brandidsArray: this.brandids,
						isbindArray: this.isbind,
						useridArray: this.userid,
					}, res => {
						if (res.code == 0) {
							this.editShow = true;
						} else {
							this.$message({
								type: 'error',
								message: res.msg,
								duration: 5000
							})
						}
					})
				} else {
					this.$message.error('请选择终端');
					this.editShow = false;
				}
			},
			rateEdit() { //编辑
				if (this.ids.length > 0) {
					this.$api.post("terminal/checkTerminalSearch", {
						brandidsArray: this.brandids,
						isbindArray: this.isbind,
						useridArray: this.userid,
					}, res => {
						if (res.code == 0) {
							this.rateIsShow = true;
						} else {
							this.$message({
								type: 'error',
								message: res.msg,
								duration: 5000
							})
						}
					})
					// var userid=true;
					// for(var i = 0; i < this.userid.length; i++){
					//     if(this.userid[i] != this.admin_id){
					//         userid=false;
					//     }
					// }
					// if(userid){
					//     console.log(this.isbind)
					//     console.log(this.isbind.indexOf("未绑定"))
					//     if(this.isbind.indexOf("已绑定") == 0){
					//         this.$message.error('存在已绑定终端');
					//     }else{

					//     }
					// }else{
					// this.$message.error('存在不直属与自己的终端');
					// }
				} else {
					this.$message.error('请选择终端');
					this.rateIsShow = false;
				}
			},

			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.getData({
					condition: JSON.stringify(this.formInline),
					page: this.page.currentPage,
					limit: this.page.pageSize,
				});
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.getData({
					condition: JSON.stringify(this.formInline),
					page: this.page.currentPage,
					limit: limit,
				})
			},
			getData() {
				this.$api.post("terminal/terminal_equipment_list", {
					condition: JSON.stringify(this.formInline),
					page: this.page.currentPage,
					limit: this.page.pageSize
				}, res => {
					let data = res.data;
					this.page.total = data.count; //总数
					this.transferList.list = res.data.list;
					let {
						total,
						total_active,
						total_bind,
						list
					} = data;
					this.tableTitle = {
						total,
						total_active,
						total_bind
					};
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			downLoad(formInline) { //导出
				// 表单提交
				// this.getDatas({
				// condition: JSON.stringify(this.formInline),
				// page: this.page.currentPage,
				// limit: this.page.pageSize,
				// })
				let reqData = {
					type: 2,
					value: JSON.stringify(formInline)
				};

				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}

				})
			},
			// getDatas(params) {
			//     this.$api.post("terminal_equipment/terminal_equipment_list_download", params, res => {
			//         if (res.code == 0) {
			//             this.$message.success(res.msg);
			//             var link=this.$file_url+res.data;
			//             window.open(link)
			//         } else {
			//             this.$message.error(res.msg);
			//         }
			//         this.loading = false;
			//     })
			// },
			pickerChange(DateArr) { //时间选择器
				this.formInline.bd_start = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.formInline.bd_end = this._.isEmpty(DateArr) ? '' : DateArr[1];

			},
			pickerChange2(DateArr) { //时间选择器
				this.formInline.jh_start = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.formInline.jh_end = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			pickerChange3(DateArr) { //时间选择器
				this.formInline.exchange_time_start = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.formInline.exchange_time_end = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			handleDefaultTime() { //默认获取三十天
				let date = new Date().getTime();
				this.formInline.bd_end = this.$moment().format("YYYY-MM-DD");
				this.formInline.bd_start = this.$moment(date - 3600 * 1000 * 24 * 30).format("YYYY-MM-DD");
				this.formInline.jh_end = this.$moment().format("YYYY-MM-DD");
				this.formInline.jh_start = this.$moment(date - 3600 * 1000 * 24 * 30).format("YYYY-MM-DD");
				this.rangeDate = [this.formInline.bd_start, this.formInline.bd_end];
				this.rangeDate2 = [this.formInline.jh_start, this.formInline.jh_end];
			},
			goTo(row) {
				this.infoIsShow = true;
				this.detail = row;
				this.$router.push({
					path: '/terminalTransaction',
					query: {
						sn: row.sn
					}
				});
			},
			//显示激活时间
			delayActiv(data) {
				//显示组建
				this.delayActivShow = true

				//想组建传入当前展示数据
				this.delayActivInfo = data
			},
			//是否显示未绑定
			isActivation(data) {

				//检测终端是否划分过 0代表在自己手里未划分 不显示延期
				if (data.user_id == 0) {
					return false;
				}

				//除了一级全都不显示
				if (this.level != 1) {
					return false;
				}

				//检测未绑定不显示
				if (data.is_active == '未激活') {
					//已绑定并且未激活显示
					return true;
				}
			},


			//批量延长时间
			terminalExtend() {
				this.is_show_activation_box = this.is_show_activation_box == true ? false : true
			},
			delayBtn() {
				//检测是否选择终端
				if (this.sn.length <= 0) {
					this.$message.error('未选择终端');
					return false;
				}

				var id = this.ids.toString();
				var sn = this.sn.toString();
				var isactive = this.isactive.toString();
				if (isactive.indexOf('已激活') > -1) {
					this.$message.error('有已激活设备 不可延长');
					return false;
				}
				if (this.activation_day <= 0 && this.activation_day != '') {
					this.$message.error('天数异常');
					return false;
				}
				var obj = {
					id: id,
					sn: sn,
					edit_activ_time: this.activation_day,
				}

				this.$api.post('terminal/delayActivInfo', obj, res => {
					if (res.code == 0) {
						this.$message.success(res.data);
						this.terminalExtend();
					} else {
						this.$message.error(res.msg);
					}
				})


			}
		}
	};
</script>





<style lang="scss" scope>
	.el-input__inner {
		font-size: 12px;
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.el-date-editor .el-range-input,
	.el-date-editor .el-range-separator {
		font-size: 12px;
	}

	.el-popover__title {
		font-size: 12px;
		font-weight: 700;
	}

	.MAM_terminalList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}

		.tableTitle {
			display: inline-block;
			margin-right: 20px;
		}
	}

	.terminal_operate {
		display: flex;
	}

	.el-button {
		font-size: 12px !important;
	}
</style>